import React from 'react';
import Allocations from '../Allocations';
import CustomTabs from '../common/CustomTabs';
import PageHeader from '../common/PageHeader';
import EmployeeDetails from './EmployeeDetails';
import { IsSectionVisible } from '../../utils/helper';
import { SECTIONS } from '../../constants/appConstants';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

class EmployeeInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      MarketDetails: undefined,
      PropertyData: undefined,
      configuration: undefined
    };
  }

  componentDidMount() {
  }

  render() {
    const Tabs = [
      {
        name: 'View Employee Details',
        id: 1,
        childComponent: (
          <EmployeeDetails
            selectedEmployeeId={this.props.selectedEmployeeId}
            onBackClick={this.props.onBackClick} />)
      }
    ];
    if (IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.MARKET_ALLOCATION)) {
      Tabs.push({
        name: 'Market Allocations',
        id: 2,
        childComponent: <Allocations
          employeeData={this.props.employeeData}
          selectedEmployeeId={this.props.selectedEmployeeId}
          // propertyData = {this.props.propertyData}
          allocationType={[{ allocationType: 'Market' }]}
          onBackClick={this.props.onBackClick}
          renderAsChild={true}
        ></Allocations>
      });
    }
    if (IsSectionVisible(SECTIONS.ALLOCATIONS, SECTIONS.PROPERTY_ALLOCATION)) {
      Tabs.push(
        {
          name: 'Property Allocations',
          id: 3,
          childComponent: <Allocations
            marketId={this.props.marketId}
            employeeData={this.props.employeeData}
            selectedEmployeeId={this.props.selectedEmployeeId}
            // propertyData = {this.props.propertyData}
            allocationType={[{ allocationType: 'Property' }]}
            onBackClick={this.props.onBackClick}
            renderAsChild={true}
          ></Allocations>
        });
    }

    return (
      <>
        <div className="col-sm-12 col-lg-12">
          <PageHeader title="Employee Details" actionsConfig={
            [
              {
                icon: <ArrowBackIcon size="small" className="back-button" />,
                onClick: this.props.onBackClick,
                title: 'Back to Employees'
              }
            ]} >
          </PageHeader>
        </div>

        <div className="row Row_flex bottom-lg">

          <CustomTabs tabsList={Tabs} currentSelectedTab={1} />

          {/* <div className="col-sm-12 col-lg-1 bottom-lg">
            <Tooltip title="Back to Market">
              <ArrowBackIcon size="small" className="back-button" onClick={this.props.onBackClick} />
            </Tooltip>
          </div> */}
        </div>
      </>
    );
  }
}

export default EmployeeInfo;
